import { motion } from 'motion/react';
import styled from 'styled-components';

export const StyledMotionExpandableContent = styled(motion.div)`
    overflow: hidden;
`;
